import React, { useState, useEffect } from 'react';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import './_customToast.scss';

const CustomToast = ({ message, type, isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // Auto close after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  const getToastColor = () => {
    switch (type) {
      case 'success':
        return '#157c2dff'
      case 'error':
        return 'danger';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  };

  const toastStyle = {
    backgroundColor: type === 'success' ? '#157c2dff' : undefined, // Custom background for success
    color: 'white', // Ensures text color is white for readability
  };

  return (
    <Toast isOpen={isOpen}
      className={`${type === 'success' ? '' : 'bg-' + getToastColor()}`}
      style={toastStyle}>
      <ToastHeader toggle={onClose}>
        {type === 'success' && 'Success'}
        {type === 'error' && 'Error'}
        {type === 'warning' && 'Warning'}
        {type === 'info' && 'Info'}
      </ToastHeader>
      <ToastBody>
        {message}
      </ToastBody>
    </Toast>
  );
};

CustomToast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CustomToast;